module.exports = __webpack_public_path__ + "img/zhangzuozhen.f1b525cf.jpg";